import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  box-sizing: border-box;
  width: 100%;
  background: url('/images/notfound.svg');
  background-position: center;
  padding-top: 4rem;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
  width: 500px;
  color: white;
  text-align: center;

  @media screen and (max-width: 600px) {
    width: calc(100% - 4rem);
    padding-left: 2rem;
    padding-right: 2rem;
  }

  h1,
  p,
  hr {
    margin: 0;
  }

  a {
    color: white;
    font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
  }

  h1 {
    font-family: ${props => props.theme.texts.titleXL.fontFamily};
    font-size: ${props => props.theme.texts.titleXL.fontSize};
  }

  p {
    font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};
    font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
  }

  img {
    height: 27px;
  }

  hr {
    width: 100%;
    border-color: ${props => props.theme.colors.grey.tone400};
  }
`
